const stickyShare = () => {
    const getOffsetTop = element => {
        let offsetTop = 0;
        while (element) {
            offsetTop += element.offsetTop;
            element = element.offsetParent;
        }
        return offsetTop;
    };
    const targetItem = document.querySelector(".sticky");
    const container = document.querySelector(".sticky-parent");
    const headerBlock = document.querySelector(".header");
    const headerBlockHeight = headerBlock.offsetHeight;
    const startPosition = getOffsetTop(targetItem) - headerBlockHeight;
    const endPosition = container.scrollHeight + startPosition - targetItem.scrollHeight;
    const setStickyPosition = () => {
        if (targetItem && container) {
            if (window.innerWidth >= 1200 && window.pageYOffset >= startPosition && window.pageYOffset <= endPosition) {
                targetItem.classList.add("stuck");
            } else {
                targetItem.classList.remove("stuck");
            }
        }
    };

    window.addEventListener("load", setStickyPosition);
    window.addEventListener("scroll", setStickyPosition);
    window.addEventListener("resize", setStickyPosition);
};

export default stickyShare;



// WEBPACK FOOTER //
// ./assets/js/modules/stickyShare.js